import { Link } from 'react-router';
import { Icon } from '../atoms/Icon';

const CODE_LINES = [
  { t: [['k','const '],['v','response'],['p',' = '],['k','await '],['fn','fetch'],['p','('],['s',"'https://client-api.fluxuro.ai/api/models/run-model'"],['p',', {']] },
  { t: [['p','  method: '],['s',"'POST'"],['p',',']] },
  { t: [['p','  headers: {']] },
  { t: [['p','    '],['s',"'x-api-key'"],['p',': '],['s',"'uro_your_key_here'"],['p',',']] },
  { t: [['p','    '],['s',"'Content-Type'"],['p',': '],['s',"'application/json'"]] },
  { t: [['p','  },']] },
  { t: [['p','  body: '],['fn','JSON'],['p','.'],['fn','stringify'],['p','({']] },
  { t: [['p','    model_id: '],['s',"'flux-1-1-ultra'"],['p',',']] },
  { t: [['p','    positive_prompt: '],['s',"'A cinematic product shot, soft lighting'"],['p',',']] },
  { t: [['p','    aspect_ratio: '],['s',"'16:9'"]] },
  { t: [['p','  })']] },
  { t: [['p','})']] },
  { t: [] },
  { t: [['k','const '],['p','{ '],['v','data'],['p',' } = '],['k','await '],['v','response'],['p','.'],['fn','json'],['p','()']] },
  { t: [['c',"// { image_job_id: 'job_8f3a...', status: 'processing' }"]] },
];

const TOKEN = {
  k:  { color: '#FF8FB1' },
  s:  { color: '#FFC2A8' },
  v:  { color: '#A5B4FC' },
  fn: { color: '#7DD3FC' },
  c:  { color: 'rgba(255,255,255,.32)', fontStyle: 'italic' },
  p:  { color: '#E5E7EB' },
};

const FEATURES = [
  'Unified API for image, video, and text',
  'OpenAI-compatible LLM endpoints',
  'Per-output pricing — no per-second surprises',
  '99.9% uptime, used in enterprise production',
  'Full async job queue with webhooks',
  'MCP compatible for AI agents',
];

export default function ApiSection() {
  return (
    <section id="api">
      <div className="container">
        <div className="eyebrow" style={{ marginBottom: 14, color: '#A5B4FC' }}>Built for engineers</div>
        <h2 className="h2" style={{ maxWidth: '22ch' }}>
          The AI API your team<br/>
          <span style={{ background: 'linear-gradient(135deg, #818CF8 0%, #A78BFA 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>
            actually wants to use.
          </span>
        </h2>

        <div className="api-grid" style={{ marginTop: 56, display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.15fr)', gap: 48, alignItems: 'center' }}>
          {/* Feature list */}
          <div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 16 }}>
              {FEATURES.map((f, i) => (
                <li key={i} className="row gap-3" style={{ alignItems: 'center' }}>
                  <span style={{ width: 28, height: 28, borderRadius: 8, display: 'grid', placeItems: 'center', background: 'rgba(99,102,241,.10)', border: '1px solid rgba(129,140,248,.30)', color: '#A5B4FC', flex: '0 0 28px' }}>
                    <Icon.check size={14} color="#A5B4FC"/>
                  </span>
                  <span style={{ fontSize: 15, color: 'var(--text-2)' }}>{f}</span>
                </li>
              ))}
            </ul>
            <div className="row gap-3" style={{ marginTop: 32, flexWrap: 'wrap' }}>
              <a className="btn btn-primary" href="#api">Read the full docs <Icon.arrow size={14}/></a>
              <Link to="/register" className="btn btn-ghost" style={{ borderColor: 'rgba(129,140,248,.4)', color: '#A5B4FC' }}>
                Get your API key <Icon.arrow size={14}/>
              </Link>
            </div>
          </div>

          {/* Code block */}
          <div className="code-card">
            <div className="row" style={{ height: 38, padding: '0 14px', borderBottom: '1px solid rgba(255,255,255,.06)', gap: 12, background: 'rgba(0,0,0,.25)' }}>
              <span style={{ display: 'inline-flex', gap: 6 }}>
                {['#FF5F57', '#FEBC2E', '#28C840'].map(c => (
                  <span key={c} style={{ width: 11, height: 11, borderRadius: '50%', background: c, opacity: .85 }}/>
                ))}
              </span>
              <div className="row gap-3 mono" style={{ marginLeft: 8, color: 'var(--text-4)', fontSize: 11 }}>
                <span>node</span>
                <span style={{ color: 'var(--text-4)' }}>·</span>
                <span>run-model.ts</span>
              </div>
              <span className="chip" style={{ marginLeft: 'auto', height: 22, fontSize: 11, background: 'rgba(16,185,129,.10)', borderColor: 'rgba(16,185,129,.3)', color: '#6EE7B7' }}>
                200 OK
              </span>
            </div>
            <pre className="mono" style={{ margin: 0, padding: 22, fontSize: 13, lineHeight: 1.7, overflowX: 'auto', color: '#E5E7EB' }}>
              {CODE_LINES.map((row, i) => (
                <div key={i} style={{ display: 'flex' }}>
                  <span style={{ color: 'rgba(255,255,255,.18)', width: 28, textAlign: 'right', paddingRight: 14, userSelect: 'none', flexShrink: 0 }}>{i + 1}</span>
                  <span>
                    {row.t.length === 0
                      ? <>&nbsp;</>
                      : row.t.map(([k, v], j) => <span key={j} style={TOKEN[k]}>{v}</span>)
                    }
                  </span>
                </div>
              ))}
            </pre>
          </div>
        </div>
      </div>
    </section>
  );
}
